import type { FaireProductEntity } from "../../entity_types/product";

export const p_8887chag4m: FaireProductEntity = {
  token: "p_8887chag4m",
  type: "product",
  name: "Essentials: Pistachio + Cardamom Candle  | 12 oz.",
  brandToken: "b_b19tidse3g",
  brandName: "BOTANICA",
  imageUrl:
    "https://cdn.faire.com/fastly/ac814201ee51b6e43c44c373d90f2bd6e1bd52fc23fca762251daa80177651bb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f6d88c9077c073e3b65c4edbfe7ff4e58b88cd85887c607a7a1a7b9c73f73460.jpeg",
    "https://cdn.faire.com/fastly/82a61d97d0d93659b81699d547d88730a57337fb17b92b8923d195c7288daa4e.jpeg",
    "https://cdn.faire.com/fastly/9d0ef81f00deda80d6ac31bedc9c62a3d21c01b906ad6b3bbbaa9a902e1077a3.jpeg",
    "https://cdn.faire.com/fastly/a47fd08ba8d7866bca77615be21869433834bb93f12b9a3047b782fed3c91e21.jpeg",
    "https://cdn.faire.com/fastly/7436ceb4e7acdba4b7ac65bef31ab2abf283736a73622dc4f576eec491a3ed5e.jpeg",
  ],
  priceDollars: 22,
  description:
    "A bit sweet, a bit salty, a bit spicy, and very unique! True pistachio notes are blended with sweet vanilla and spicy cardamom to create this balanced, elevated gourmand candle that is perfectly at home in the kitchen or boudoir. The Botanica Essentials Candle Collection features pure essential oils, balanced with nuanced fragrance oils to create provocative and true-to-nature scents. \n\nIndigenous Fragrance Notes: Pistachio, Cardamom, Vanilla\n\n• SOY & COCONUT WAX CANDLE | 100% COTTON WICK \n• 12 oz. | 70+ HOUR BURN TIME",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:49.861Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
